/* global $:false */

export default class FAQ {
  static init () {
    $('[data-faq-question]').on('click', '.content a', event => event.stopPropagation())

    $('[data-faq-section]').on('click', function (event) {
      event.preventDefault()
      this.el = $(this)
      const slug = this.el[0].id

      const questionsAreHidden = $(`#section_${slug}`).is(':hidden')

      $('[data-faq-questions]:visible').slideToggle('slow')
      $('[data-faq-answer]:visible').slideToggle('slow')
      $('[data-feedback]:visible').slideToggle('slow')

      const icons = $('.c-faq dd').find('icon')
      icons.removeClass('c-faq__angle-up').addClass('c-faq__angle-down')

      if (questionsAreHidden) {
        $(`#section_${slug}`).slideToggle('slow')
      }
    })

    $('[data-faq-question]').on('click', function (event) {
      event.preventDefault()
      this.el = $(this)
      const slug = this.el[0].id

      const answerIsHidden = $(`#question_${slug}`).is(':hidden')

      $('[data-faq-answer]:visible').slideToggle('slow')
      $('[data-feedback]:visible').slideToggle('slow')

      const icons = $('.c-faq dd').find('icon')
      icons.removeClass('c-faq__angle-up').addClass('c-faq__angle-down')

      if (answerIsHidden) {
        $(`#question_${slug}`).slideToggle('slow')
        this.el.find('icon').toggleClass('c-faq__angle-down c-faq__angle-up')
        const parent = this.el.closest('dd')
        const feedback = parent.find('[data-feedback]')
        feedback.slideToggle('slow')
      }
    })

    $('[data-feedback-yes]').on('click', function (event) {
      event.preventDefault()
      event.stopPropagation()
      this.el = $(this)

      const parent = this.el.closest('[data-feedback]')
      const thankYouMessage = parent.find('[data-feedback-response-yes]')
      if (thankYouMessage.is(':hidden')) {
        const options = parent.find('[data-feedback-options]')
        options.slideToggle('slow')
        thankYouMessage.slideToggle('slow')
      }
    })

    $('[data-feedback-no]').on('click', function (event) {
      event.preventDefault()
      event.stopPropagation()
      this.el = $(this)

      const parent = this.el.closest('[data-feedback]')
      const linkToRegistrationForm = parent.find('[data-feedback-response-no]')
      if (linkToRegistrationForm.is(':hidden')) {
        const options = parent.find('[data-feedback-options]')
        options.slideToggle('slow')
        linkToRegistrationForm.slideToggle('slow')
      }
    })
  }
}
